import module from 'fan/proyecto/module.js'
import template from './template.html'

export class FanProyectoFilialesComponent {
  constructor($filter, FanProyectoFilialesService) {
    this.orderBy = $filter('orderBy')
    this.FanProyectoFilialesService = FanProyectoFilialesService
    this.idProyecto = undefined
  }

  $onInit() {
    this.agregando = false
    this.actualizando = false
    this.seleccionado = null
    this.data = null

    return this.FanProyectoFilialesService.get(this.idProyecto)
      .then((response) => (this.data = this.orderBy(response.data, 'Nombre')))
  }

  actualizar(item, data) {
    this.data.splice(this.data.indexOf(item), 1, data)

    if (data.Master) {
      this.data = this.data.map((item) => {
        item.Master = item.ID_Cliente === data.ID_Cliente

        return angular.copy(item)
      })
    }

    this.seleccionado = null
  }

  agregar(data) {
    this.agregando = false
    this.actualizando = true
    this.seleccionado = null

    return this.FanProyectoFilialesService.post(this.idProyecto, data)
      .then((response) => (this.data = this.orderBy(this.data.concat([response.data]), 'Nombre')))
      .finally(() => (this.actualizando = false))
  }

  eliminar(item) {
    this.data.splice(this.data.indexOf(item), 1)
  }
}

module.component('fanProyectoFiliales', {
  template: template,
  controller: FanProyectoFilialesComponent,
  bindings: {
    idProyecto: '<',
  },
})



// WEBPACK FOOTER //
// ./src/fan/proyecto/components/filiales/component.js